import { useState } from "react";
import { PlugDisconnectedRegular } from "@fluentui/react-icons";
import { AppButton, MessageScreen } from "../components/common";

interface ITeamsTechnicalErrorPage {
  onRetry: () => void | Promise<void>;
}

const TeamsTechnicalErrorPage: React.FC<ITeamsTechnicalErrorPage> = ({ onRetry }) => {
  const [isRetrying, setIsRetrying] = useState(false);

  const handleRetry = async () => {
    if (isRetrying) return;
    setIsRetrying(true);
    try {
      await onRetry();
    } finally {
      setIsRetrying(false);
    }
  };

  return (
    <MessageScreen
      icon={<PlugDisconnectedRegular fontSize={36} />}
      title="Nie udało się połączyć z Microsoft Teams"
      descriptions={[
        "Odśwież kartę lub spróbuj ponownie za chwilę.",
        "Jeśli problem się powtarza, skontaktuj się z administratorem.",
      ]}
      action={<AppButton text="Spróbuj ponownie" onClick={handleRetry} disabled={isRetrying} />}
    />
  );
};

export default TeamsTechnicalErrorPage;
